<template>
    <div class="content-with-image">
      <div class="col-graduate-left">
        <a :id="slug"></a>
        <div class="graduate-image-box">
          <img :data-src="image" class="lazyload graduate-image" />
          <div class="graduate-position">
            {{ position }}
          </div>
        </div>
      </div>
      <div class="col-interview-right">
        <div class="interview-title">
          <h1>
            <em style="font-weight: normal;">Interview:</em>
            {{ position }}
          </h1>
        </div>
        <div class="interview" v-html="content"></div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Col2Graduate',

  data: function () {
    return {
    }
  },

  props: {
    image: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    },
    position: {
      type: String,
      required: false,
      default: ''
    },
    slug: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted () {
    if (this.$route.hash !== '') {
      const el = document.querySelector(this.$route.hash)
      el && el.scrollIntoView()
    }
  }
}
</script>

<style>
.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.interview {
  column-count: 1;
  padding-top: 20px;
  padding-bottom: 20px;
}

.graduate-image {
  max-width: 350px;
  border-radius: 10px;
}

.graduate-position {
  padding-top: 10px;
  padding-bottom: 10px;
}

.graduate-image-box {
  background-color: #d0e3f3;
  border-bottom-right-radius: 80px;
  padding: 20px;
  text-align: left;
}

.call-to-action-btn {
  font-size: 15px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.content-with-image {
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
}

.content-with-image .col-graduate-left {
  justify-content: space-around;
  order: 1;
  flex-basis: 20%;
}

.content-with-image .col-interview-right {
  justify-content: space-around;
  order: 2;
  flex-grow: 1;
  flex-basis: 50%;
}

.content-with-image ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

.content-with-image li {
  color: #000;
  font-size: 15px;
  display: table-row;
}

.content-with-image li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .content-with-image {
    flex-direction: column;
  }

  .content-with-image .col-graduate-left {
    flex-basis: 100%;
  }

  .graduate-image {
    max-width: 100%;
  }

  .graduate-image-box {
    margin-bottom: 20px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .content-with-image {
    flex-direction: column;
  }

  .content-with-image .col-graduate-left {
    flex-basis: 100%;
  }

  .graduate-image-box {
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    max-width: 390px;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content-with-image {
    flex-direction: column;
  }

  .content-with-image .col-graduate-left {
    flex-basis: 100%;
  }

  .content-with-image .col-interview-right {
    flex-basis: 100%;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content-with-image {
    flex-direction: row;
  }

  .content-with-image .col-graduate-left {
    flex-basis: 20%;
    margin-left: 20px;
    margin-right: 20px;
  }

  .content-with-image .col-interview-right {
    flex-basis: 50%;
    margin-right: 20px;
  }

  .interview {
    column-count: 2;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content-with-image {
    flex-direction: row;
  }

  .content-with-image .col-graduate-left {
    flex-basis: 390px;
    margin-right: 40px;
  }

  .content-with-image .col-interview-right{
    flex-basis: 60%;
  }
}
</style>
